import {MidiDeviceHolder} from "./MidiDeviceHolder";

export {MidiMessage}

class MidiMessage {
    midiEvent: WebMidi.MIDIMessageEvent;
    source:MidiDeviceHolder;

    constructor(midiEvent: WebMidi.MIDIMessageEvent, source:MidiDeviceHolder) {
        this.midiEvent = midiEvent;
        this.source = source;
    }
}